import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import ColumnBase from "./ColumnBase";
import { getAlertBell, openGeneralWidgetFromGridRecord } from "../../other/utils/utils.jsx";
import { WIDGET_REGISTRY } from "../../other/constants/EntityManagerConfig.tsx";
import { ALERT_TYPES, ICON_COL_DEF_WIDTH, REMINDER_STATE } from "../../other/constants/OtherKeys.jsx";

const isHasTriggeredButNotSeenReminder = (column) => {
  return !!column.grid.store.findRecord(column.field, REMINDER_STATE.NOT_SEEN, true);
}

// by default, bryntum doesn't trigger to re-render of header/column on record update
const updateHeaderBellIcon = (column) => {
  //Bug: Listener is not being triggered in entity's reminder Tab
  //Todo: When brytum version is updated, use refreshHeader function
  // https://bryntum.com/products/schedulerpro/docs/api/Grid/column/Column#function-refreshHeader
  return column.grid.on("dataChange", () => {
    if (column.textElement) {
      column.textElement.innerHTML = column.headerRenderer({ column });
    }
  });
}

export default class AlertBellColumn extends ColumnBase {
  static get $name() {
    return "AlertBellColumn";
  }

  static get type() {
    return WIDGET_KEYS.alertBellColumn;
  }

  static get fields() {
    return [
      { name: "isAlertBell", type: "boolean", defaultValue: false }
    ]
  }

  onLoad(project, otherParams) {
    this.project = project;
    this.editorHandler = otherParams?.editorHandler;
    if (!this.swivuHasDataChangeEvent) {
      this.swivuHasDataChangeEvent = updateHeaderBellIcon(this);
    }
  }

  onSwivuColumnClick(e) {
    openGeneralWidgetFromGridRecord(this.editorHandler, e.record, WIDGET_REGISTRY.timeline.id, {
      idSuffix: "timeline-reminders",
      otherParams: { initialMode: "reminders" },
    });
  }

  static get defaults() {
    return {
      // text is used in the filter bar
      text: "Reminder",
      width: 30,
      minWidth: ICON_COL_DEF_WIDTH,
      editor: false,
      searchable: false,
      align: "center",
      cellCls: "cursor-pointer",
      field: "reminderState",
      // prevent dropping columns to this one
      sealed: true,
      filterable: false,
      cls: "swivu-icon-column",
      // in the header we want to see only icon
      headerRenderer({ column }) {
        return getAlertBell({
          reminderState: isHasTriggeredButNotSeenReminder(column) ? REMINDER_STATE.NOT_SEEN: null,
          isAlertBell: column.isAlertBell
        });
      },
      htmlEncode: false,
      renderer({ record, column }) {
        return getAlertBell({
          reminderState: record[this.field],
          isAlertBell: column.isAlertBell || record.alertType === ALERT_TYPES.REMINDER
        });
      },
      groupRenderer({ groupRowFor: reminderState }) {
        if (reminderState === REMINDER_STATE.SEEN) return "Seen";
        if (reminderState === REMINDER_STATE.NOT_SENT) return "Not Sent";
        if (reminderState === REMINDER_STATE.NOT_SEEN) return "Not Seen";
        if (reminderState === REMINDER_STATE.FAILED) return "Failed To Deliver";
        return "No Reminder";
      },
    };
  }
}

ColumnStore.registerColumnType(AlertBellColumn);
